
<ng-template #factorReturnModal let-modal class="modal modal-top fade">
    <div class="modal-header border-bottom p-3">
      <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
        {{ "FactorReturn" | translate }}
      </h6>
      <button
        type="button"
        class="btn-close-modal btn-icon btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
  
    <div class="modal-body">
      <div class="card-modal mx-3">
        <div class="row mx-3 my-0">
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">شماره فاکتور:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.factorId }}
            </p>
          </div>
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">تاریخ فاکتور:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.dateTime | dataType : "" }}
            </p>
          </div>
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">نام شرکت:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.companyName }}
            </p>
          </div>
        </div>
        <div class="row mx-3 my-0">
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">قیمت کل:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.totalPrice }}
            </p>
          </div>
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">تخفیف:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.discount }}
            </p>
          </div>
          <div class="col-2 fs-6 fw-bold">
            <span class="px-0 pe-0">وضعیت:</span>
          </div>
          <div class="col-2 fs-6">
            <p class="m-0 px-0">
              {{ factor.state }}
            </p>
          </div>
        </div>
        <div class="row mx-3 my-0 border-ridge">
          <div class="col-2 fs-6 fw-bold">
            <span class="m-0 px-0">توضیحات: </span>
          </div>
          <div class="col-10 fs-6">
            <p class="m-0 px-0">
              {{ factor.description }}
            </p>
          </div>
        </div>
      </div>
  
      <div class="row p-1 m-0">
        <div class="mvc-grid-table">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">{{ "Row" | translate }}</th>
                <th scope="col">{{ "drugBrandName" | translate }}</th>
                <th scope="col">{{ "Number" | translate }}</th>
                <th scope="col">{{ "expireDate" | translate }}</th>
                <th scope="col">{{ "buyPrice" | translate }}</th>
                <th scope="col">{{ "buyDiscount" | translate }}</th>
                <th scope="col">{{ "TotalAmount" | translate }}</th>
                <th scope="col">{{ "ReturnCount" | translate }}</th>
              </tr>
            </thead>
            <tbody id="rows">
              <tr *ngFor="let item of factor.finalDrugList; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.drugName }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.expireDate }}</td>
                <td>
                  {{ item.buyPrice | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  {{ item.discount | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  {{ item.totalPrice | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  <input
                    id="ReturnCount"
                    type="number"
                    autocomplete="off"
                    appSelectOnFocus
                    class="form-control"
                    [(ngModel)]="item.returnCount"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
      <div class="row p-1 m-0">
        <div class="col-12 top-input-box mt-3">
          <label for="description" class="form-label m-0"
            >{{ "description" | translate }}:</label
          >
          <textarea
            id="description"
            type="text"
            class="form-control"
            placeholder="{{ 'description' | translate }}"
            >{{ factor.returnDescription }}
                  </textarea
          >
        </div>
      </div>
  
      <!-- <app-pctable [data]="data" (parentAction)="insideTableAction($event)"></app-pctable> -->
    </div>
  
    <div class="modal-footer border-top p-3">
      <button
        type="submit"
        class="btn btn-primary me-sm-3 me-1 data-submit"
      >
        {{ "Submit" | translate }}
      </button>
      <button
        type="reset"
        class="btn btn-label-secondary"
        (click)="modal.dismiss('Cross click')"
      >
        {{ "Cancel" | translate }}
      </button>
    </div>
  </ng-template>
  